<template>
    <div class="components-page__QSSearchGroupItem">
        <p class="components-page__QSSearchGroupItem__header" v-show="isShowHeader">
            <slot name="header">
                <h5>{{title}}</h5>
            </slot>
        </p>
        <section class="components-page__QSSearchGroupItem__section">
            <slot></slot>
        </section>
    </div>
</template>

<script>
export default {
  name: 'QSSearchGroupItem',
  inject: ['blmSearchInstance'],
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    isShowHeader() {
      return this.blmSearchInstance.showAll
    },
  },
}
</script>

<style lang="less" scoped>
.components-page__QSSearchGroupItem {
    &__header {
        h5 {
            margin-left: 0;
            font-size: 16px;
        }
    }
    &__section {
        display: flex;
        flex-wrap: wrap;
        * {
            display: inherit;
        }
    }
}
</style>
